import { render, staticRenderFns } from "./globalModals.vue?vue&type=template&id=63c23f62&scoped=true&"
import script from "./globalModals.vue?vue&type=script&lang=js&"
export * from "./globalModals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c23f62",
  null
  
)

export default component.exports